import { Result } from 'types';
import { PoinzApiClient } from '../../api';

const VERSION = '/v2';
const WEB = '/web';
const USER_DEVICES = '/user-devices';

const apiRoot = `${VERSION}${WEB}${USER_DEVICES}`;

const confirmUserDevice =
  (apiClient: PoinzApiClient) =>
  async (code: string): Promise<void> => {
    await apiClient.get(`${apiRoot}/confirmation`, {
      queryParams: {
        code
      }
    });
  };

const resendConfirmationEmail =
  (apiClient: PoinzApiClient) =>
  async (deviceId: string): Promise<void> => {
    const result = await apiClient.post(`${apiRoot}/resend-confirmation-email`, {
      queryParams: { deviceId }
    });

    return result.body;
  };

export default (apiClient: PoinzApiClient) => ({
  confirm: confirmUserDevice(apiClient),
  resendConfirmationEmail: resendConfirmationEmail(apiClient)
});
